<app-base-page-template>
  <app-base-page-content-template>
    <app-jobs-grid
      (rowClick)="onRowClicked($event)"
      (addButtonClick)="onAddButtonClicked()">
    </app-jobs-grid>
  </app-base-page-content-template>
</app-base-page-template>
